<div class="dropdown w-100">
    <button class="btn btn-secondary text-xs-left dropdown-toggle w-100" type="button" (click)="isOpen = !isOpen"
            [class.ng-invalid]="isInvalid">
        {{selectName}}
    </button>
    <div class="dropdown-menu bg-gray" [class.show]="isOpen">
        <div class="m-a-1" *ngIf="items?.length > 10 || hasMultiplePages">
            <input type="text" placeholder="Filter" autocomplete="off" class="form-control" [(ngModel)]="searchText"
                   name="filter" (keyup)="onFilter()">
        </div>

        <a *ngFor="let item of items" class="dropdown-item" [class.hide]="!item.isEnabled"
           [class.selected]="item.isSelected" (click)="onToggleSelection(item, !item.isSelected)"
           href="javascript:void(0)">
            <div class="selected-icon">
                <i class="fas fa-check text-success" [class.hide]="!item.isSelected"></i>
            </div>
            {{item.displayName}}
        </a>

        <div class="dropdown-item" *ngIf="isLoading">
            <i class="fas fa-spinner fa-pulse"></i> Loading...
        </div>

        <button type="button" class="btn btn-primary stretch m-t-0" *ngIf="canLoadMore()" [disabled]="isLoading"
                (click)="onLoadMore()">
            <i class="fas fa-caret-square-down" aria-hidden="true"></i> Load More
        </button>
    </div>

    <div *ngIf="isInvalid" class="validation-error">
        Select at least one item
    </div>
</div>

<div class="table-responsive" *ngIf="selectedItems?.length">
    <table class="table table-sm m-b-0">
        <tbody>
        <tr *ngFor="let item of selectedItems">
            <td>{{item.displayName}}</td>
            <td class="col-icon text-center">
                <i class="btn fas fa-minus-circle pointer" aria-hidden="true"
                   (click)="onToggleSelection(item, false)"></i>
            </td>
        </tr>
        </tbody>
    </table>
</div>
